import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useCurrentSignUp_event$key } from "./__generated__/useCurrentSignUp_event.graphql";

export const useCurrentSignUp = (
  fragmentRef: useCurrentSignUp_event$key | null
) => {
  const data = useFragment(useCurrentSignUpFragmentString, fragmentRef);

  return data?.signUpForClient;
};

export const useCurrentSignUpFragmentString = graphql`
  fragment useCurrentSignUp_event on Event {
    signUpForClient(clientId: $memberId) {
      signUpWindow {
        cancelDeadlineAt
      }
      waitlistIndex
      id
      canDelete
      checkedIn
      ownerClient {
        ... on Member {
          id
          memberOwnerId: id
          firstName
          lastName
          fullName
          profileImage {
            # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
            publicId: renderingKey
          }
        }
        ... on Customer {
          id
          fullName
          profileImage {
            # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
            publicId: renderingKey
          }
        }
      }
      registrations {
        edges {
          node {
            id
            type
            index
            ... on MemberEventRegistration {
              payingMember {
                id
              }
            }
            ... on GuestEventRegistration {
              payingMember {
                id
              }
              unknownRegistrantDisplayName
            }

            ... on CustomerEventRegistration {
              payingCustomer {
                id
              }
              unknownRegistrantDisplayName
            }

            primaryChargeType {
              id
              chargeRuleSet {
                displayName
                displayDescription
              }
            }
            registrant {
              id
              firstName
              lastName
              profileImage {
                # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
                publicId: renderingKey
              }
              ... on Member {
                phoneNumber {
                  nationalNumber
                }
                departmentMemberProfiles(type: GOLF) {
                  ... on GolfMemberProfile {
                    ghinNumber
                    department {
                      slug
                    }
                  }
                }
              }
              ... on Customer {
                phoneNumber {
                  nationalNumber
                }
                departmentMemberProfiles(type: GOLF) {
                  ... on GolfMemberProfile {
                    ghinNumber
                    department {
                      slug
                    }
                  }
                }
              }
              email
            }
            formResponses {
              edges {
                node {
                  id
                  booleanValue
                  stringValue
                  transportationType {
                    id
                  }
                  questionConfiguration {
                    enabled
                    id
                    type
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
